// Sentry MUST be imported before everything else so its hooks are in place.
import { initializeSentry } from "./instrument";
initializeSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Friendly fallback when a top-level error escapes the app's own error
// boundaries. Designed to avoid the "white screen of death" — users see a
// recoverable message and can retry.
function RootErrorFallback({ resetError }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: 24,
      fontFamily: 'system-ui, -apple-system, sans-serif', textAlign: 'center',
    }}>
      <div style={{ maxWidth: 480 }}>
        <h1 style={{ fontSize: 28, marginBottom: 8, color: '#0f1115' }}>Something went sideways.</h1>
        <p style={{ color: '#4b5563', lineHeight: 1.6, marginBottom: 24 }}>
          We've been notified and are looking into it. Reload the page or try
          again in a moment.
        </p>
        <button
          onClick={resetError}
          style={{
            background: '#002fa7', color: '#fff', border: 'none',
            padding: '12px 24px', fontWeight: 600, cursor: 'pointer',
            fontSize: 14,
          }}
          data-testid="root-error-retry"
        >
          Try again
        </button>
        <a
          href="/"
          style={{ display: 'block', marginTop: 16, color: '#6b7280', fontSize: 13 }}
        >
          Or go home →
        </a>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={RootErrorFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
